import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedAdminRoute } from "@/components/admin/ProtectedAdminRoute";
import { LegacyBrandRedirect } from "@/components/site/LegacyBrandRedirect";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import SectionPage from "@/pages/SectionPage";
import ReportPage from "@/pages/ReportPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSection from "@/pages/admin/AdminSection";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/research/:sectionKey" element={<SectionPage />} />
          <Route path="/company/:slug" element={<ReportPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
          <Route path="/admin/section/:sectionKey" element={<ProtectedAdminRoute><AdminSection /></ProtectedAdminRoute>} />

          {/* Legacy KIRA Markets → KIRA Score redirects (301-equivalent client-side) */}
          <Route path="/kira-markets/*" element={<LegacyBrandRedirect />} />
          <Route path="/kiramarkets/*" element={<LegacyBrandRedirect />} />
          <Route path="/kira_markets/*" element={<LegacyBrandRedirect />} />
          <Route path="/kira-market/*" element={<LegacyBrandRedirect />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
